import name from './name'

const selectSliceData = state => state[name]
const selectPlaylistProgressData = state => selectSliceData(state).progressData
const selectPlaylistIds = state => selectSliceData(state).playlistIds
const selectProgress = state => selectSliceData(state).progress
const selectLoadingIndicator = state => selectSliceData(state).loadingIndicator

export { selectSliceData, selectPlaylistProgressData, selectPlaylistIds, selectProgress, selectLoadingIndicator }
